define('modules/reporting/shared/main',["T1Module"], function (T1Module) {
  "use strict";

  return new T1Module({
    defaultView: "",
    name: "reporting/shared",
    viewCfgs: {}
  });
});
